import React from "react";

import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";

import { NavbarResponsive } from "../../common/components/NavbarResponsive";
import { PALETTE } from "../../common/ThemeConstants";
import NavLinkButton from "../../common/components/NavLinkButton";

export default function ProfileHeader({ tabs }) {
  return (
    <NavbarResponsive>
      <Container
        className="text-center"
        style={{ width: "100%", display: "block" }}
      >
        <Row>
          {Object.keys(tabs).map((key, index) => (
            <Col key={index}>
              <NavLinkButton
                text={tabs[key]}
                to={"/account/Profile/" + key}
                borderColor={PALETTE.LIGHTGRAY}
                color={PALETTE.GRAY}
                backgroundColorHover={PALETTE.GRADIENTLIGHT}
                colorHover={PALETTE.SECONDARYCOLORHOVER}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </NavbarResponsive>
  );
}
